var map = {
	"./additional-functionalities.png": "BnrD",
	"./additional_functionalities.png": "Xmlh",
	"./creditDebit.png": "pSbC",
	"./dashStat.png": "iGSX",
	"./eInvoiceGen.png": "RkZG",
	"./invoice.png": "KRGj",
	"./manage.png": "FOL7",
	"./myDevices.png": "o64c",
	"./myInvoices.png": "tZi4",
	"./my_devices.png": "/8UP",
	"./my_invoices.png": "oCEg",
	"./newReg.png": "yEZL",
	"./receipt.png": "a6o/",
	"./send-icon.png": "WSdv",
	"./serviceProvider.png": "CDF6",
	"./simplified.png": "MyXd",
	"./sme.png": "F6D/",
	"./solCert.png": "2zyj",
	"./solReg.png": "nKzC",
	"./specialBilling.png": "K4gN",
	"./standard.png": "ibD4",
	"./tabler_file-description.png": "4Zi7",
	"./taxReturn.png": "40sy",
	"./techFailNot.png": "9ez4",
	"./viewInvoices.png": "/a3y"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "IrsO";